<template>
  <div class="options">
    <search v-model="search" class="search" />
    <el-button type="primary" icon="el-icon-plus" @click="showDialog = true">New price</el-button>
    <el-dialog :append-to-body="true" width="400px" :top="$screen.mobile ? '0vh' : '15vh'" custom-class="full-width-mobile" title="Add new price" :visible.sync="showDialog">
      <upsert-form
        v-if="showDialog"
        :stations="organization.stations"
        :groups="organization.groups || []"
        @created="created"
        :users="users" />
    </el-dialog>
  </div>
</template>

<script>
import UpsertForm from './UpsertForm'
import Search from './../SearchInput'

export default {
  name: 'PricingOptions',
  components: { UpsertForm, Search },
  props: {
    organization: {
      type: Object,
      required: true
    }
  },
  computed: {
    users () {
      return this.organization.users.map(user => {
        return user.user
      })
    }
  },
  data () {
    return {
      search: '',
      showDialog: false
    }
  },
  watch: {
    search () {
      this.$emit('search', this.search)
    }
  },
  methods: {
    created (price) {
      this.$emit('created', price)
      this.showDialog = false
    }
  }
}
</script>

<style lang="scss" scoped>
  .options {
    width: 50%;
    display: flex;
    justify-content: flex-end;
    align-items: center;

    @include breakpoint (xs) {
      width: 100%;
      flex-direction: column;

      button {
        height: 60px;
        width: 100%;
      }
    } 
  }

  .search {
    width: 100%;
    margin-right: 20px;

    @include breakpoint (xs) {
      margin-right: 0px;
    } 
  }
</style>



// WEBPACK FOOTER //
// src/components/dashboard/organizations/organization/lists/Pricing/Options.vue